<template>
  <div>
    <page-header
      icon="mdi-truck-delivery-outline"
      :title="$t('orders')"
      :subtitle="$t('manage_delivery_orders')"
    />

    <page-toolbar
      v-model="search"
      :search-placeholder="$t('search_delivery_orders_placeholder')"
      :searchable="false"
    >
      <template #filters>
        <v-col cols="auto">
          <date-picker
            v-model="date"
            single-date
            :label="$t('date')"
            hide-details
            color="white"
            @input="onFiltersChanged"
          />
        </v-col>

        <v-col cols="auto">
          <autocomplete
            :items="[
              { id: 2, name: $t('prepared_for_delivery1') },
              { id: 3, name: $t('booked_by_delivery') },
              { id: 4, name: $t('ready') },
              { id: 5, name: $t('taken_by_delivery1') },
              { id: 6, name: $t('delivered_11') },
              { id: 9, name: $t('order_not_taken1') },
            ]"
            item-text="name"
            item-value="id"
            :label="$t('group_meal2')"
            return-object
            v-model="status_id"
            @input="onFiltersChanged"
            color="white"
          />
        </v-col>
        <v-col cols="auto">
          <text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            hide-details
            color="white"
            style="max-width: 250px"
          />
        </v-col>

        <v-col>
          <v-row no-gutters justify="end">
            <print-button @click="print('print')" class="mr-2" />
            <global-confirm-box ref="confirmBox" />
            <primary-button
              v-if="!$store.state.user.user.type == 'dostava'"
              @click="dialog = true"
            >
              <v-icon class="mr-2">mdi-plus-circle</v-icon>
              {{ $t("companies_delivery") }}
            </primary-button>
          </v-row>
        </v-col>
      </template>
    </page-toolbar>

    <div style="width: 95%; margin: 15px auto">
      <global-dialog-card
        v-model="dialog"
        :title="formTitle"
        :subtitle="editedItem ? `ID: ${editedItem?.id}` : ''"
      >
        <v-container style="padding-bottom: 10px !important">
          <v-row>
            <v-col cols="12">
              <text-field
                v-model="editedItem.name"
                :rules="[$t('mandatory_field')]"
                :label="$t('title')"
                required
              ></text-field>
            </v-col>
            <v-col v-if="desserts.length" cols="12">
              <autocomplete
                v-model="editedItem.parent"
                :items="
                  [{ name: '', id: null }].concat(desserts.filter((item) => item.id))
                "
                :label="$t('parent_company')"
                item-text="name"
                item-id="id"
                return-object
              ></autocomplete>
            </v-col>
            <v-row class="px-3">
              <v-col cols="6" class="mb-0 pb-0">
                <autocomplete
                  @change="getCity()"
                  v-model="editedItem.country"
                  :items="countries"
                  :label="$t('country')"
                  item-text="name"
                  item-id="id"
                  return-object
                ></autocomplete>
              </v-col>
              <v-col cols="6" class="mb-0 pb-0">
                <autocomplete
                  v-model="editedItem.city"
                  @change="getRestaurantsByCity()"
                  :items="cities || []"
                  :label="$t('city')"
                  item-text="name"
                  item-id="id"
                  return-object
                ></autocomplete>
              </v-col>
            </v-row>
            <v-col cols="12">
              <text-field
                v-model="editedItem.address"
                :label="$t('address')"
              ></text-field>
            </v-col>
            <v-row class="px-3">
              <v-col cols="6" class="mb-0 pb-0">
                <text-field v-model="editedItem.latitude" :label="$t('lati1')">
                </text-field>
              </v-col>
              <v-col cols="6" class="mb-0 pb-0">
                <text-field v-model="editedItem.longitude" :label="$t('long1')">
                </text-field>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col cols="6">
                <text-field v-model="editedItem.phone" :label="$t('phone')"></text-field>
              </v-col>
              <v-col cols="6">
                <text-field
                  v-model="editedItem.email"
                  :label="$t('email')"
                  required
                ></text-field>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col cols="6">
                <text-field v-model="editedItem.jib" :label="$t('jib')"></text-field>
              </v-col>
              <v-col cols="6">
                <text-field v-model="editedItem.pib" :label="$t('pib')"></text-field>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col cols="4">
                <text-field v-model="editedItem.owner" :label="$t('owner')"></text-field>
              </v-col>
              <v-col cols="4">
                <text-field
                  v-model="editedItem.contact_person"
                  :label="$t('contact_person')"
                ></text-field>
              </v-col>
              <v-col cols="4">
                <text-field
                  v-model="editedItem.contract"
                  :label="$t('contract')"
                ></text-field>
              </v-col>
              <v-col cols="4">
                <autocomplete
                  v-model="companyCurrency"
                  :items="currencyOptions"
                  item-text="text"
                  item-value="val"
                  :label="$t('select_currency')"
                ></autocomplete>
              </v-col>
            </v-row>
            <v-col cols="12">
              <text-area
                class="polje"
                v-model="editedItem.description"
                :label="$t('note')"
              ></text-area>
            </v-col>
            <v-col cols="12" class="mb-4 pb-0">
              <h4 class="mb-6">{{ $t("pay_type") }}</h4>
              <div style="display: flex; justify-content: space-between">
                <v-switch
                  v-model="editedItem.paying_type"
                  inset
                  :label="$t('by_month')"
                  :false-value="0"
                  :true-value="1"
                  @change="changeAmountMonth()"
                  dense
                ></v-switch>
                <v-switch
                  v-model="editedItem.paying_type"
                  inset
                  :label="$t('by_percent')"
                  @change="changeAmountPercent()"
                  :false-value="0"
                  :true-value="2"
                  dense
                ></v-switch>
                <v-switch
                  v-model="editedItem.paying_type"
                  inset
                  :label="$t('by_meal')"
                  @change="changeAmountMeal()"
                  :false-value="0"
                  :true-value="3"
                  dense
                ></v-switch>
              </div>
              <span v-if="editedItem.paying_type">
                <text-field
                  type="number"
                  v-model="editedItem.paying"
                  :label="
                    $t('amount') +
                    ' ' +
                    (editedItem.paying_type == 2
                      ? '%'
                      : $store.state.restaurant.settings.price || '')
                  "
                ></text-field>
              </span>
            </v-col>
          </v-row>
        </v-container>
        <template #actions>
          <v-btn text @click="close">
            {{ $t("cancel") }}
          </v-btn>
          <primary-button @click="save">{{ $t("save") }}</primary-button>
        </template>
      </global-dialog-card>

      <v-data-table
        style="margin-top: 5px"
        :headers="headers"
        :items="desserts"
        :search="search"
        class="ordera-box-shadow striped-table"
        id="print"
        dense
        show-expand
      >
        <template
          v-for="header in headers"
          v-slot:[`header.${header.value}`]="{ header }"
        >
          {{ $t(header.text) }}
        </template>
        <template v-for="values in headers" v-slot:[`item.${values.value}`]="{ item }">
          {{ translate(item[values.value]) }}
        </template>
        <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
          <template v-if="item.children && item.children.length">
            <v-btn
              :style="
                'border-radius: 8px;border: 1px solid ' +
                $store.state.restaurant.settings.topbar.background +
                ';background: none;color: ' +
                $store.state.restaurant.settings.topbar.background +
                ';box-shadow: none;text-transform: capitalize'
              "
              dark
              small
              rounded
              @click="expand(true)"
              v-if="!isExpanded"
            >
              <v-icon>mdi-arrow-down</v-icon>
              {{ $t("branches") }}
            </v-btn>
            <v-btn color="primary" dark small rounded @click="expand(false)" v-else>
              <v-icon>mdi-arrow-up</v-icon>
              {{ $t("hide") }}
            </v-btn>
          </template>
        </template>

        <template v-slot:expanded-item="{ item, isExpanded, expand }">
          <template v-if="item.children">
            <td :colspan="headers.length" class="pa-0">
              <v-data-table
                dense
                :headers="headers"
                class="ordera-box-shadow striped-table"
                :items="item.children || []"
                :items-per-page="item.children.length"
                hide-default-footer
                hide-default-header
              >
                <v-spacer></v-spacer>
                <template v-slot:item.is_credit="{ item, index }">
                  <div
                    v-if="
                      $store.state.user.user.type == 'restaurant' ||
                      $store.state.user.user.type == 'admin'
                    "
                    class="text-right"
                  >
                    <span class="d-flex">
                      <v-checkbox
                        v-model="item.is_credit"
                        @change="setCredit(item, index)"
                      ></v-checkbox>
                      <circle-button
                        @click="openCredit(item)"
                        color="success"
                        icon="mdi-currency-eur"
                        :tooltip="$t('tooltip_manage_credit')"
                      />
                    </span>
                  </div>
                </template>
                <template v-slot:item.actions="{ item, index }">
                  <v-btn
                    small
                    color="primary"
                    text
                    class="mx-2"
                    :to="{
                      name: 'firma-id-korisnici',
                      params: {
                        id: item.id,
                        name: item.name,
                        parent_id: item.parent_id,
                      },
                    }"
                  >
                    {{ $t("users") }} {{ item.users_count }}
                  </v-btn>
                  <edit-button class="mr-2" @click="editItem(item)"></edit-button>
                  <v-icon
                    :title="$t('settings')"
                    small
                    class="mr-2"
                    @click="openSettings(item)"
                  >
                    mdi-cog-outline</v-icon
                  >
                  <remove-button @click="deleteItem(item)"></remove-button>
                </template>
              </v-data-table>
            </td>
          </template>
        </template>
        <template v-slot:item.is_credit="{ item, index }">
          <div
            v-if="
              $store.state.user.user.type == 'restaurant' ||
              $store.state.user.user.type == 'admin'
            "
            class="text-right"
          >
            <span class="d-flex">
              <v-checkbox
                v-model="item.is_credit"
                @change="setCredit(item, index)"
              ></v-checkbox>
              <circle-button
                @click="openCredit(item)"
                color="success"
                icon="mdi-currency-eur"
                :tooltip="$t('tooltip_manage_credit')"
              />
            </span>
          </div>
        </template>
        <template
          v-if="
            $store.state.user.user.type == 'dostava' ||
            $store.state.user.user.type == 'admin_delivery'
          "
          v-slot:item.restaurant_name="{ item, index }"
        >
          <circle-button
            @click="opentRestoranLocation(item)"
            class="mr-2"
            icon="mdi-map-marker"
            :tooltip="$t('tooltip_show_restaurant_location')"
          />
          <span :title="item.restaurant_phone">{{ item.restaurant_name }}</span>
        </template>
        <template
          v-if="
            $store.state.user.user.type == 'dostava' ||
            $store.state.user.user.type == 'admin_delivery'
          "
          v-slot:item.status_order="{ item, index }"
        >
          {{
            statuses.find((id) => id.id == item.status_order)
              ? $t(statuses.find((id) => id.id == item.status_order).name)
              : ""
          }}
        </template>
        <template v-slot:item.actions="{ item }">
          <circle-button
            icon="mdi-silverware-fork-knife"
            @click="showOrders(item)"
            :title="$t('orders') + ' ' + item.order_id"
          />
          <span v-if="item.status_order == 5">
            <v-btn
              small
              color="primary"
              style="border: 1px solid; border-radius: 7px"
              text
              class="mx-2"
              @click.prevent="acceptOrder(item, 4)"
            >
              Zaduzio dostavljac
            </v-btn>
            <v-btn
              small
              color="primary"
              text
              class="mx-2"
              @click.prevent="cancelOrder(item)"
            >
              <span
                style="
                  color: red;
                  border: 1px solid red;
                  padding: 1px 5px;
                  border-radius: 7px;
                "
                >Otkazi</span
              >
            </v-btn>
          </span>
          <span v-if="item.status_order == 4">
            <v-btn
              small
              color="primary"
              style="border: 1px solid; border-radius: 7px"
              text
              class="mx-2"
              @click.prevent="orderDelivered(item)"
            >
              Isporuceno
            </v-btn>
            <v-btn
              small
              color="primary"
              style="border: 1px solid; border-radius: 7px"
              text
              class="mx-2"
              @click.prevent="cancelOrder(item)"
            >
              <span
                style="
                  color: red;
                  border: 1px solid red;
                  padding: 1px 5px;
                  border-radius: 7px;
                "
                >Otkazi</span
              >
            </v-btn>
          </span>
          <span v-if="item.status_order == 3">
            <v-btn
              small
              color="primary"
              style="border: 1px solid; border-radius: 7px"
              text
              class="mx-2"
              @click.prevent="orderDelivered(item)"
            >
              Isporuceno
            </v-btn>
            <v-btn
              small
              color="primary"
              text
              class="mx-2"
              @click.prevent="cancelOrder(item)"
            >
              <span
                style="
                  color: red;
                  border: 1px solid red;
                  padding: 1px 5px;
                  border-radius: 7px;
                "
                >Otkazi</span
              >
            </v-btn>
          </span>
          <v-btn
            v-if="
              item.status_order != 3 &&
              item.status_order != 5 &&
              item.status_order != 4 &&
              item.status_order != 6
            "
            small
            style="border: 1px solid; border-radius: 7px"
            color="primary"
            text
            class="mx-2"
            @click.prevent="acceptOrder(item, 3)"
          >
            Rezervisi
          </v-btn>
          <span v-if="item.status_order == 6">ISPORUCENO</span>
        </template>
      </v-data-table>
      <global-dialog-card
        v-model="openModalAddCredit"
        :max-width="700"
        :title="canSeeStoredCredit ? $t('credit') : $t('add_credit')"
        :subtitle="modalCreditItems?.id ? 'ID: ' + modalCreditItems.id : ''"
      >
        <template #title-actions>
          <v-btn dark text @click="editNewCredit()">{{ $t("edit_credit") }} </v-btn>
          <v-btn dark text @click="addNewCredit()">{{ $t("add_credit1") }} </v-btn>
        </template>
        <autocomplete
          v-if="canSeeStoredCredit"
          :label="$t('credit')"
          v-model="credit"
          :items="storedCredits"
          hide-details
          v-on:change="selectCredit"
          item-value="id"
          item-text="name"
        />
        <div v-if="canSeeInputFields">
          <text-field
            v-model="modalCreditItems.naziv"
            :label="$t('add_title')"
          ></text-field>
          <v-row>
            <v-col>
              <v-switch
                v-model="modalCreditItems.percent"
                inset
                :label="$t('percent')"
              ></v-switch>
            </v-col>
            <v-col>
              <text-field
                type="number"
                v-model="modalCreditItems.rabat"
                :label="$t('add_rabat')"
              ></text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <date-picker
                v-model="modalCreditItems.date_from"
                :label="$t('inital_date')"
                single-date
              />
            </v-col>
            <v-col>
              <date-picker
                v-model="modalCreditItems.date_to"
                :label="$t('ending_date')"
                single-date
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-switch
                v-model="modalCreditItems.active"
                inset
                :label="$t('status')"
              ></v-switch>
            </v-col>
          </v-row>
        </div>
        <template #actions>
          <v-btn text @click="openModalAddCredit = false">
            {{ $t("cancel") }}
          </v-btn>
          <primary-button @click="storeCredit()">
            {{ $t("save") }}
          </primary-button>
        </template>
      </global-dialog-card>
      <v-dialog v-model="openModalSettings" max-width="80%" scrollable>
        <v-card>
          <v-card-title
            class="primary"
            style="width: 100%; display: flex; justify-content: space-between"
          >
            <span
              style="
                font-size: 20px !important;
                justify-content: space-between;
                width: 95%;
              "
              class="headline white--text text-center d-flex"
            >
              {{ $t("join_restoran") }} | {{ firm.name }} | {{ "ID: " + firm.id }}
            </span>
            <span
              @click.prevent="openModalSettings = false"
              style="
                color: white;
                padding: 1px 12px;
                border-radius: 50px;
                border: 1px solid;
                cursor: pointer;
              "
            >
              x
            </span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <v-row class="px-3 py-2">
              <v-col cols="4" class="mb-0 pb-0">
                <autocomplete
                  @change="getCity()"
                  v-model="editedItem.country"
                  :items="countries"
                  :label="$t('country')"
                  item-text="name"
                  item-id="id"
                  return-object
                />
              </v-col>
              <v-col cols="4" class="mb-0 pb-0">
                <autocomplete
                  v-model="editedItem.city"
                  @change="getRestaurantsByCity()"
                  :items="cities ? cities : []"
                  :label="$t('city')"
                  item-text="name"
                  item-id="id"
                  return-object
                />
              </v-col>
              <v-col cols="4" class="mb-0 pb-0">
                <text-field
                  v-model="search_res"
                  prepend-inner-icon="mdi-magnify"
                  :label="$t('search')"
                ></text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <h3 class="px-8 mb-4 text-center" v-if="restornani">
            {{ $t("restaurants") }}
          </h3>
          <v-data-table
            dense
            :headers="headersRes"
            class="ordera-box-shadow striped-table"
            :items="restornani ? restornani : []"
          >
            <template
              v-for="header in headersRes"
              v-slot:[`header.${header.value}`]="{ header }"
            >
              {{ $t(header.text) }}
            </template>
            <template v-slot:item.check="{ item }">
              <label :for="item.id">
                <input
                  v-if="
                    item.restoran_delivery_company.length &&
                    item.restoran_delivery_company.find(
                      (id) => id.restaurant_id == item.id
                    ).restaurant_id
                  "
                  @change="selectRestoran(item)"
                  :id="item.id"
                  style="cursor: pointer"
                  :value="item.id"
                  v-model="
                    item.restoran_delivery_company.find(
                      (id) => id.restaurant_id == item.id
                    ).restaurant_id
                  "
                  type="checkbox"
                />
                <input
                  v-else
                  @change="selectRestoran(item)"
                  :id="item.id"
                  style="cursor: pointer"
                  :true-value="item.id"
                  v-model="item.restaurant_id"
                  type="checkbox"
                />
              </label>
            </template>
            <template v-slot:item.active_restoran="{ item }">
              <label
                v-if="
                  item.restoran_delivery_company.length &&
                  item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
                    .restaurant_id
                "
                :for="item.id"
              >
                <input
                  :id="item.id"
                  style="cursor: pointer"
                  :value="item"
                  v-model="
                    item.restoran_delivery_company.find(
                      (id) => id.restaurant_id == item.id
                    ).active_restoran
                  "
                  type="checkbox"
                />
              </label>
              <label v-else :for="item.id">
                <input
                  :id="item.id"
                  style="cursor: pointer"
                  :value="item"
                  v-model="item.active_restoran"
                  type="checkbox"
                />
              </label>
            </template>
            <template v-slot:item.active_company="{ item }">
              <label
                v-if="
                  item.restoran_delivery_company.length &&
                  item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
                    .restaurant_id
                "
                :for="item.id"
              >
                <input
                  :id="item.id"
                  style="cursor: pointer"
                  :value="item.id"
                  v-model="
                    item.restoran_delivery_company.find(
                      (id) => id.restaurant_id == item.id
                    ).active_company
                  "
                  type="checkbox"
                />
              </label>
              <label v-else :for="item.id">
                <input
                  :id="item.id"
                  style="cursor: pointer"
                  :value="item.id"
                  v-model="item.active_company"
                  type="checkbox"
                />
              </label>
            </template>
            <template v-slot:item.paying_type="{ item }">
              <select
                v-if="
                  item.restoran_delivery_company.length &&
                  item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
                    .restaurant_id
                "
                style="padding: 6px 15px"
                v-model="
                  item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
                    .paying_type
                "
                id=""
              >
                <option
                  v-for="item in [
                    { name: $t('choose'), val: 0 },
                    { name: $t('by_month'), val: 1 },
                    { name: $t('by_percent'), val: 2 },
                    { name: $t('by_meal'), val: 3 },
                  ]"
                  :value="item.val"
                >
                  {{ item.name }}
                </option>
              </select>
              <select v-else style="padding: 6px 15px" v-model="item.paying_type" id="">
                <option
                  v-for="item in [
                    { name: $t('choose'), val: 0 },
                    { name: $t('by_month'), val: 1 },
                    { name: $t('by_percent'), val: 2 },
                    { name: $t('by_meal'), val: 3 },
                  ]"
                  :value="item.val"
                >
                  {{ item.name }}
                </option>
              </select>
            </template>
            <template v-slot:item.paying="{ item }">
              <text-field
                v-if="
                  item.restoran_delivery_company.length &&
                  item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
                    .restaurant_id
                "
                v-model="
                  item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
                    .paying
                "
                :label="$t('amount')"
                hide-details
              ></text-field>
              <text-field
                v-else
                v-model="item.paying"
                :label="$t('amount')"
                hide-details
              ></text-field>
            </template>
            <template v-slot:item.internal="{ item }">
              <label
                v-if="
                  item.restoran_delivery_company.length &&
                  item.restoran_delivery_company.find((id) => id.restaurant_id == item.id)
                    .restaurant_id
                "
                :for="item.id"
              >
                <input
                  :id="item.id"
                  style="cursor: pointer"
                  :value="item.id"
                  v-model="
                    item.restoran_delivery_company.find(
                      (id) => id.restaurant_id == item.id
                    ).internal
                  "
                  type="checkbox"
                />
              </label>
              <label v-else :for="item.id">
                <input
                  :id="item.id"
                  style="cursor: pointer"
                  :value="item.id"
                  v-model="item.internal"
                  type="checkbox"
                />
              </label>
            </template>
          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModalSettings()">
              {{ $t("cancel") }}
            </v-btn>
            <primary-button @click="storeFirmSettings()">
              {{ $t("save") }}
            </primary-button>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <global-dialog-card
        v-model="orders"
        :max-width="1200"
        :title="`ID: ${single_order.id}`"
        hide-actions
      >
        <template v-for="order in single_order.order_guest_transactions">
          <div
            :style="
              order.meals || order.food
                ? 'border-bottom: 1px dashed rgba(0, 0, 0, 0.12)'
                : ''
            "
            style="width: 100%"
            class="d-flex justify-content-center align-content-center w-100"
          >
            <div
              :title="
                order.meals || order.food
                  ? translate(order.meals ? order.meals.name : order.food.name)
                  : ''
              "
              style="
                width: 55%;
                padding-bottom: 2px;
                font-size: 16px;
                color: rgba(0, 0, 0, 0.87);
                font-weight: 500;
              "
            >
              {{ order.meals || order.food ? order.quantity + "x " : "" }}
              <span style="text-transform: uppercase">{{
                order.meals || order.food
                  ? translate(order.meals ? order.meals.name : order.food.name)
                  : ""
              }}</span>
            </div>
            <div
              style="width: 45%; text-align: right; font-size: 16px; padding-bottom: 2px"
            >
              {{
                order.meals || order.food
                  ? order.meals
                    ? order.meals.price * order.quantity
                    : order.food.price * order.quantity
                  : ""
              }}
            </div>
          </div>
          <div v-if="order.prilog.length" v-for="prilog in order.prilog">
            <div
              v-if="prilog.quantity > 0"
              style="color: rgba(0, 0, 0, 0.54); width: 100%; text-transform: lowercase"
              class="d-flex justify-content-center align-content-center"
            >
              <div
                style="
                  width: 56%;
                  font-size: 16px;
                  padding-bottom: 2px;
                  color: rgba(0, 0, 0, 0.5);
                "
              >
                - {{ prilog.quantity }}x {{ translate(prilog.food.name) }}
              </div>
              <div
                style="
                  width: 45%;
                  text-align: right;
                  font-size: 16px;
                  padding-bottom: 2px;
                "
              >
                {{ prilog.quantity * prilog.price }}
              </div>
            </div>
          </div>
        </template>
        <div
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"
          class="d-flex justify-content-center align-content-center w-100"
        >
          <div style="width: 50%; font-size: 16px; padding-bottom: 2px; font-weight: 500">
            {{ $t("delivery") }}:
          </div>
          <div
            style="
              width: 50%;
              text-align: right;
              font-size: 16px;
              padding-bottom: 2px;
              font-weight: 500;
            "
          >
            +
            {{
              $store.state.restaurant.settings.guest.restoran_delivery
                ? $store.state.restaurant.settings.guest.delivery_price
                : ""
            }}
          </div>
        </div>
        <div class="d-flex justify-content-center align-content-center">
          <div style="width: 55%; font-size: 12px; padding-bottom: 2px; font-weight: 700">
            {{ $t("totalU") }}
            {{
              $store.state.restaurant.settings && $store.state.restaurant.settings.price
                ? "(" + $store.state.restaurant.settings.price + ")"
                : ""
            }}:
          </div>
          <div
            style="
              width: 45%;
              text-align: right;
              font-size: 12px;
              padding-bottom: 2px;
              font-weight: 700;
            "
          >
            {{ priceMeals(single_order) }}
          </div>
        </div>
      </global-dialog-card>

      <global-dialog-card
        v-model="restoran_location"
        hide-actions
        :title="[$t('lokacija'), restoran_item.restaurant_name].join(' ')"
      >
        <p class="mt-2">
          {{ $t("address") }}:
          <span class="font-weight-bold">
            {{ translate(restoran_item.restaurant_address) }}
          </span>
        </p>
        <p>
          {{ $t("city") }}:
          <span class="font-weight-bold">
            {{ translate(restoran_item.restaurant_city_name) }}
          </span>
        </p>
        <p>
          {{ $t("lati") }}:
          <span class="font-weight-bold">
            {{ translate(restoran_item.restaurant_latitude) }}
          </span>
        </p>
        <p>
          {{ $t("long") }}:
          <span class="font-weight-bold">
            {{ translate(restoran_item.restaurant_longitude) }}
          </span>
        </p>
        <p>
          <a
            target="_blank"
            :href="
              'https://www.google.com/maps/search/?api=1&query= ' +
              restoran_item.restaurant_latitude +
              ' ,' +
              restoran_item.restaurant_longitude
            "
          >
            Google maps
          </a>
        </p>
      </global-dialog-card>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import conf from "@/config";
import hasSnackbar from "@/mixins/hasSnackbar";
import restaurantService from "@/services/restaurant";
import orderService from "@/services/order";
import companyService from "@/services/company";
import {
  CURRENCY_OPTIONS,
  parseSettings,
  hasCurrencyMismatch,
  getRestaurantCurrency,
  getDeliveryCompanyCurrency,
} from "@/utils/currency";
export default {
  mixins: [hasSnackbar],
  data: () => ({
    conf: conf,
    dialog: false,
    firm: {
      settings: {
        confirm_delivery: false,
        order_from_one_shift_to_another: true,
        can_see_report: false,
      },
    },
    cities: [],
    search: "",
    search_res: "",
    date: new Date().toISOString().substr(0, 10),
    on: undefined,
    attrs: undefined,
    credit: "",
    menu_type: "",
    status_id: 2,
    restoran_location: false,
    restoran_item: false,
    openModalAddCredit: false,
    openModalSettings: false,
    openModalEditCredit: false,
    canSeeStoredCredit: true,
    canSeeInputFields: false,
    orders: false,
    menu: null,
    menu1: null,
    modalEditCreditItems: "",
    modalCreditItems: {
      naziv: "",
      rabat: "",
      percent: "",
      date_from: null,
      date_to: null,
      active: "",
      date: "",
    },
    statuses: [
      { id: 2, name: "prepared_for_delivery1" },
      { id: 3, name: "booked_by_delivery" },
      { id: 4, name: "ready" },
      { id: 5, name: "taken_by_delivery1" },
      { id: 6, name: "delivered_11" },
      { id: 9, name: "order_not_taken1" },
    ],
    storedCredits: [],
    headersRes: [
      {
        text: "status",
        align: "center",
        value: "check",
      },
      {
        text: "id",
        align: "end",
        value: "id",
      },
      {
        text: "name",
        align: "start",
        value: "name",
      },
      {
        text: "status_restoran",
        align: "start",
        value: "active_restoran",
        sortable: false,
      },
      {
        text: "status_company",
        align: "start",
        value: "active_company",
        sortable: false,
      },
      {
        text: "pay_type",
        align: "start",
        value: "paying_type",
        sortable: false,
      },
      {
        text: "amount",
        align: "start",
        value: "paying",
        sortable: false,
      },
      {
        text: "internal",
        align: "start",
        value: "internal",
        sortable: false,
      },
    ],
    headers: [
      {
        text: "restaurant",
        align: "start",
        value: "restaurant_name",
      },
      {
        text: "date",
        align: "start",
        value: "delivery_date",
        sortable: true,
      },
      {
        text: "time",
        align: "start",
        value: "delivery_time",
        sortable: true,
      },
      {
        text: "delivery_address",
        align: "start",
        value: "delivery_address",
        sortable: false,
      },
      {
        text: "status",
        align: "start",
        value: "status_order",
        sortable: true,
      },
      {
        text: "actions",
        align: "center",
        value: "actions",
        sortable: false,
      },
      {
        text: "",
        value: "data-table-expand",
      },
    ],
    desserts: [],
    editedIndex: -1,
    editedParentIndex: -1,
    editedItem: {
      name: "",
      restaurant_id: [],
      active_restoran: [],
      active_company: [],
      paying_type: [],
      paying: [],
      internal: [],
      city: "",
      address: "",
      phone: "",
      email: "",
      lib: "",
      pib: "",
      description: "",
      state: 1,
      checkReport: 0,
      shift_one: 1,
      shift_two: 2,
      shift_three: 3,
      contract: 1,
      lat: "",
      long: "",
      type: "small",
    },
    defaultItem: {
      name: "",
      delivery: [],
      restaurant_id: [],
      active_restoran: [],
      active_company: [],
      paying_type: [],
      paying: [],
      internal: [],
      city: "",
      address: "",
      phone: "",
      email: "",
      lib: "",
      pib: "",
      description: "",
      state: 1,
      checkReport: 0,
      shift_one: 1,
      shift_two: 2,
      shift_three: 3,
      contract: 1,
      lat: "",
      long: "",
      type: "small",
    },
    user: "",
    delivery_from: [
      { text: "00", val: "00" },
      { text: "01", val: "01" },
      { text: "02", val: "02" },
      { text: "03", val: "03" },
      { text: "04", val: "04" },
      { text: "05", val: "05" },
      { text: "06", val: "06" },
      { text: "07", val: "07" },
      { text: "08", val: "08" },
      { text: "09", val: "09" },
      { text: "10", val: "10" },
      { text: "11", val: "11" },
      { text: "12", val: "12" },
      { text: "13", val: "13" },
      { text: "14", val: "14" },
      { text: "15", val: "15" },
      { text: "16", val: "16" },
      { text: "17", val: "17" },
      { text: "18", val: "18" },
      { text: "19", val: "19" },
      { text: "20", val: "20" },
      { text: "21", val: "21" },
      { text: "22", val: "22" },
      { text: "23", val: "23" },
      { text: "24", val: "24" },
    ],
    delivery_to: [
      { text: "00", val: "00" },
      { text: "15", val: "15" },
      { text: "30", val: "30" },
      { text: "45", val: "45" },
    ],
    countries: "",
    restornani: "",
    single_order: "",
    choosedDate: "",
  }),

  computed: {
    filteredItems() {
      let query = this.search_res.toLowerCase();
      if (query === "") {
        return this.restornani;
      } else {
        return this.restornani.filter((item) => item.name.toLowerCase().includes(query));
      }
    },
    menuTypes() {
      return [
        { text: this.$t("small"), val: "small" },
        { text: this.$t("large"), val: "large" },
      ];
    },
    currencyOptions() {
      return CURRENCY_OPTIONS;
    },
    // Valuta firme za dostavu se čuva unutar settings JSON-a, pod ključem `currency`.
    companyCurrency: {
      get() {
        return parseSettings(this.editedItem.settings).currency || null;
      },
      set(value) {
        const settings = parseSettings(this.editedItem.settings);
        settings.currency = value;
        this.$set(this.editedItem, "settings", settings);
      },
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("new_company_delivery")
        : this.$t("change_companies_delivery");
    },
    getRole() {
      let usr = "";
      this.user.restaurants.filter((restoran) => {
        restoran.users.filter((user) => {
          if (user.id == this.user.id) {
            usr = user;
          }
        });
      });
      return usr;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    "editedItem.contract"(newParam, oldParam) {
      if (newParam == 0) {
        this.menu_type.push({
          text: "за госта",
          val: "guest_meal",
        });
      }
      if (newParam == 1) {
        this.menu_type = [
          { text: this.$t("small"), val: "small" },
          { text: this.$t("large"), val: "large" },
        ];
      }
    },
  },

  created() {
    this.initialize();
    this.getCountry();
    this.user = this.$store.state.user.user;

    this.$root.$on("changeWebSite", (site) => {
      this.initialize();
    });
  },

  methods: {
    opentRestoranLocation(item) {
      this.restoran_location = true;
      this.restoran_item = item;
    },
    cancelOrder(item) {
      item["delivery_user"] = this.$store.state.user.user.id;
      orderService
        .cancelDeliveryUserStatus(item)
        .then(({ data }) => {
          this.desserts.filter((item) => {
            if (item.order_id == data.id) {
              item.status_order = data.state;
            }
          });
          this.showSuccessSnackbar(this.$t("order_cancelled"));
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_cancelling_order"));
        });
    },
    orderDelivered(item) {
      item["delivery_user"] = this.$store.state.user.user.id;
      orderService
        .deliveredUserStatus(item)
        .then(({ data }) => {
          this.desserts.filter((item) => {
            if (item.order_id == data.id) {
              item.status_order = data.state;
            }
          });
          this.showSuccessSnackbar(this.$t("order_delivered"));
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_updating_order_status"));
        });
    },
    acceptOrder(item, status) {
      item["delivery_user"] = this.$store.state.user.user.id;
      item["state"] = status;
      orderService
        .deliveryUserChangeStatus(item)
        .then(({ data }) => {
          this.desserts.filter((item) => {
            if (item.order_id == data.id) {
              item.status_order = data.state;
            }
          });
          this.showSuccessSnackbar(this.$t("order_status_updated"));
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_updating_order_status"));
        });
    },
    getSelectedStatusId() {
      if (this.status_id && typeof this.status_id === "object") {
        return this.status_id.id || 2;
      }
      const parsed = Number(this.status_id);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 2;
    },
    onFiltersChanged() {
      this.choosedDate = this.date || moment().format("YYYY-MM-DD");
      this.loadDeliveryOrdersForDay(this.choosedDate, this.getSelectedStatusId());
    },
    loadDeliveryOrdersForDay(day, status) {
      this.desserts = [];
      let statuses = "";
      let days = "";
      if (status) {
        statuses = status;
      } else {
        statuses = 2;
      }

      if (day == "") {
        days = moment().format("YYYY-MM-DD");
      } else {
        days = moment(day).format("YYYY-MM-DD");
      }
      orderService
        .getDeliveryUserOrders({
          user_id: this.$store.state.user.user.id,
          date: days,
          status: statuses,
        })
        .then(({ data }) => {
          data.filter((item) => {
            this.desserts.push(item);
          });
          this.$forceUpdate();
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_orders"));
        });
    },
    priceMeals(meal) {
      let total = 0;
      let totalP = 0;
      if (meal && meal.order_guest_transactions) {
        meal.order_guest_transactions.filter((m) => {
          if (m.prilog && m.prilog.length) {
            m.prilog.filter((pr) => {
              totalP += parseFloat(pr.price) * pr.quantity;
            });
          }
          if (m.meals && m.meals.price) {
            total += parseFloat(m.meals.price) * (m.quantity ? m.quantity : 1);
          } else if (m.food && m.food.price) {
            total += parseFloat(m.food.price) * (m.quantity ? m.quantity : 1);
          }
        });
      }

      return (
        total +
        totalP +
        parseFloat(
          this.$store.state.restaurant.settings.guest.restoran_delivery
            ? this.$store.state.restaurant.settings.guest.delivery_price
            : 0
        )
      );
    },
    async selectRestoran(item) {
      const link =
        item.restoran_delivery_company &&
        item.restoran_delivery_company.length
          ? item.restoran_delivery_company.find((r) => r.restaurant_id == item.id)
          : null;
      const isChecked = link ? !!link.restaurant_id : !!item.restaurant_id;
      // Upozorenje ima smisla samo kad dispečer UKLJUČUJE saradnju sa restoranom.
      if (!isChecked) return;
      if (!hasCurrencyMismatch(item, this.firm)) return;
      try {
        await this.$refs.confirmBox.open(
          this.$t("currency_mismatch_title"),
          this.$t("currency_mismatch_warning", {
            restaurant: item.name,
            restaurantCurrency: getRestaurantCurrency(item),
            companyCurrency: getDeliveryCompanyCurrency(this.firm),
          }),
          { color: "warning", width: 460 }
        );
      } catch (e) {
        // Korisnik je odustao - poništi čekiranje.
        if (link) link.restaurant_id = null;
        else item.restaurant_id = false;
        this.$forceUpdate();
      }
    },
    getRestaurantsByCity() {
      this.restornani = "";
      restaurantService
        .getRestaurantsByCity(this.editedItem.city)
        .then(({ data }) => {
          this.restornani = data;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_restaurants"));
        });
    },
    getCity() {
      this.cityes = [];
      let cityes = [];
      this.countries.filter((item) => {
        item.city.filter((city) => {
          this.editedItem.country.city.filter((c) => {
            if (city.id == c.id) {
              cityes.push(city);
            }
          });
        });
      });
      this.cities = cityes;
    },
    getCountry() {
      restaurantService
        .getCountriesAll()
        .then(({ data }) => {
          this.countries = data;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_countries"));
        });
    },
    changeAmountMonth() {
      if (this.editedItem.by_month == 1) {
        this.editedItem.by_month = 1;
      } else {
        this.editedItem.by_month = 0;
      }
      this.editedItem.by_percent = 0;
      this.editedItem.by_meal = 0;
      this.editedItem.by_percent_input = "";
      this.editedItem.by_meal_input = "";
      this.$forceUpdate();
    },
    changeAmountPercent() {
      this.editedItem.by_meal = 0;
      this.editedItem.by_month = 0;
      if (this.editedItem.by_percent == 2) {
        this.editedItem.by_percent = 2;
      } else {
        this.editedItem.by_percent = 0;
      }
      this.editedItem.by_month_input = "";
      this.editedItem.by_meal_input = "";
      this.$forceUpdate();
    },
    changeAmountMeal() {
      if (this.editedItem.by_meal == 3) {
        this.editedItem.by_meal = 3;
      } else {
        this.editedItem.by_meal = 0;
      }
      this.editedItem.by_month = 0;
      this.editedItem.by_percent = 0;
      this.editedItem.by_month_input = "";
      this.editedItem.by_percent_input = "";
      this.$forceUpdate();
    },
    storeFirmSettings() {
      let data = {};
      data["restorani"] = this.restornani;
      data["delivery_company"] = this.firm;
      data["restoran_id"] = this.$store.state.restaurant.id;
      companyService
        .storeDeliveryCompanyRestaurants(data)
        .then(() => {
          this.showSuccessSnackbar(this.$t("saved_successfully"));
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_saving_settings"));
        });
    },
    closeModalSettings() {
      this.openModalSettings = false;
    },
    openSettings(item) {
      this.openModalSettings = true;
      if (item.settings == null) {
        item.settings = {
          shift_one: {
            delivery_from: "",
            delivery_to: "",
            delivery_from1: "",
            delivery_to1: "",
          },
          shift_two: {
            delivery_from: "",
            delivery_to: "",
            delivery_from1: "",
            delivery_to1: "",
          },
          shift_three: {
            delivery_from: "",
            delivery_to: "",
            delivery_from1: "",
            delivery_to1: "",
          },
          confirm_delivery: false,
          order_from_one_shift_to_another: true,
          can_see_report: false,
        };
      } else {
        if (typeof item.settings == "string") {
          if (!JSON.parse(item.settings).order_from_one_shift_to_another) {
            JSON.parse(item.settings)["order_from_one_shift_to_another"] = true;
          }
          item.settings = JSON.parse(item.settings);
        }
      }
      this.firm = item;
      this.$forceUpdate();
    },
    editNewCredit() {
      this.canSeeStoredCredit = true;
      this.canSeeInputFields = false;
      this.credit = "";
      this.modalCreditItems.naziv = "";
      this.modalCreditItems.rabat = "";
      this.modalCreditItems.percent = "";
      this.modalCreditItems.date_from = "";
      this.modalCreditItems.date_to = "";
      this.modalCreditItems.active = "";
      this.modalCreditItems.date = "";
    },
    addNewCredit() {
      this.canSeeStoredCredit = false;
      this.canSeeInputFields = true;
      this.modalCreditItems.naziv = "";
      this.modalCreditItems.rabat = "";
      this.modalCreditItems.percent = "";
      this.modalCreditItems.date_from = "";
      this.modalCreditItems.date_to = "";
      this.modalCreditItems.active = "";
      this.modalCreditItems.date = "";
    },
    creditIsActive(credits) {
      companyService.setCreditActive(credits).then(({ data }) => {
        this.storedCredits.filter((item) => {
          if (item.id == data.id) {
            item = data;
          }
        });
      });
    },
    selectCredit() {
      this.storedCredits.filter((item) => {
        if (item.id == this.credit) {
          this.modalCreditItems = item;
          this.modalCreditItems["naziv"] = item.name;
          this.modalCreditItems["id"] = item.id;
          this.modalCreditItems = {
            ...item,
            naziv: item.name,
            date_from: new Date().toISOString().substr(0, 10),
            date_to: new Date().toISOString().substr(0, 10),
          };
        }
      });
      this.canSeeInputFields = true;
    },
    storeCredit() {
      companyService
        .saveCredit(this.modalCreditItems)
        .then(({ data }) => {
          if (data) {
            this.openModalAddCredit = false;
            this.modalCreditItems.naziv = "";
            this.modalCreditItems.rabat = "";
            this.modalCreditItems.percent = "";
            this.modalCreditItems.date_from = "";
            this.modalCreditItems.date_to = "";
            this.modalCreditItems.active = "";
            this.modalCreditItems.date = "";
            this.credit = "";
            this.showSuccessSnackbar(this.$t("saved_successfully"));
          }
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_saving_credit"));
        });
    },
    getCredit(id) {
      companyService
        .getCredit(id)
        .then(({ data }) => {
          this.storedCredits = data;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_credit"));
        });
    },
    openCredit(item) {
      this.getCredit(item.id);
      this.openModalAddCredit = true;
      this.canSeeStoredCredit = true;
      this.modalCreditItems = item;
    },
    setCredit(item, index) {
      companyService.setIsCredit(item.id, item);
    },
    initialize() {
      orderService.deliveryOrder({ res_id: 91 });
      let days = "";
      this.desserts = [];
      let status = this.getSelectedStatusId();
      if (this.choosedDate == "") {
        days = this.date
          ? moment(this.date).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD");
        this.choosedDate = days;
      } else {
        days = moment(this.choosedDate).format("YYYY-MM-DD");
      }
      orderService
        .getDeliveryUserOrders({
          user_id: this.$store.state.user.user.id,
          date: days,
          status: status,
        })
        .then(({ data }) => {
          data.filter((item) => {
            this.desserts.push(item);
          });
        });
      orderService.getGuestOrderDetails(158).then(({ data }) => {
        this.single_order = data;
      });
    },

    editItem(item) {
      if (item.parent_id) {
        this.editedIndex = this.desserts.findIndex((i) => i.id === item.parent_id);
        this.editedParentIndex = this.desserts[this.editedIndex].children.findIndex(
          (i) => (i.id = item.id)
        );
      } else {
        this.editedIndex = this.desserts.indexOf(item);
      }

      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    showOrders(item) {
      orderService
        .getGuestOrderDetails(item.order_id)
        .then(({ data }) => {
          this.orders = true;
          this.single_order = data;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_order_details"));
        });
    },

    deleteItem(item) {
      if (item.parent_id) {
        this.editedIndex = this.desserts.findIndex((i) => i.id === item.parent_id);
        this.editedParentIndex = this.desserts[this.editedIndex].children.findIndex(
          (i) => (i.id = item.id)
        );
      } else {
        this.editedIndex = this.desserts.indexOf(item);
      }
      this.editedItem = Object.assign({}, item);

      this.$refs.confirmBox
        .open(this.$t("delete_confirmation"), this.$t("confirm_delete_company"), {
          color: "error",
        })
        .then(() => {
          this.deleteItemConfirm();
        });
    },

    deleteItemConfirm() {
      companyService
        .deleteCompany(this.editedItem.id)
        .then((res) => {
          if (this.editedParentIndex > -1) {
            this.desserts[this.editedIndex].children.splice(this.editedParentIndex, 1);
          } else {
            this.desserts.splice(this.editedIndex, 1);
          }
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
          this.editedParentIndex = -1;
          this.showSuccessSnackbar(this.$t("deleted_successfully"));
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_deleting_company"));
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.editedParentIndex = -1;
      });
    },

    save() {
      this.editedItem.parent_id = this.editedItem.parent ? this.editedItem.parent.id : 0;
      if (this.editedIndex > -1 || this.editedParentIndex > -1) {
        let _editedIndex = this.editedIndex;
        let _editedParentIndex = this.editedParentIndex;
        let _editedItem = this.editedItem;

        companyService
          .updateDeliveryCompany(this.editedItem.id, this.editedItem)
          .then((res) => {
            if (_editedParentIndex > -1) {
              Object.assign(
                this.desserts[_editedIndex].children[_editedParentIndex],
                _editedItem
              );
            } else {
              Object.assign(this.desserts[_editedIndex], _editedItem);
            }
            this.showSuccessSnackbar(this.$t("saved_successfully"));
          })
          .catch((error) => {
            this.showErrorSnackbar(error, this.$t("error_saving_company"));
          });
      } else {
        let _editedItem = this.editedItem;
        companyService
          .createDeliveryCompany(this.editedItem)
          .then((res) => {
            _editedItem.id = res.data.id;
            if (_editedItem.parent_id) {
              let i = this.desserts.findIndex((i) => i.id === _editedItem.parent_id);
              this.desserts[i].children.push(_editedItem);
            } else {
              this.desserts.push(_editedItem);
            }
            this.showSuccessSnackbar(this.$t("saved_successfully"));
          })
          .catch((error) => {
            this.showErrorSnackbar(error, this.$t("error_saving_company"));
          });
      }
      this.close();
    },
    print(id, type = false) {
      const prtHtml = document.getElementById(id).innerHTML;
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
                                    <html>
                                      <head>
                                        ${stylesHtml}

                                      </head>
                                      <body>
                                        ${prtHtml}
                                      </body>
                                    </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
  },
};
</script>
<style>
.dani_porudzbe {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.vreme .v-text-field__details {
  display: none;
}
.okolo {
  margin: 0 !important;
}

@media (max-width: 767px) {
  .okolo {
    display: block;
  }
  .v-card__text b {
    font-size: 16px;
  }
  #stampaj {
    display: none;
  }
}
.polje textarea {
  line-height: 0.9rem !important;
}
@media (max-width: 450px) {
  .v-toolbar__title,
  .v-toolbar__content hr {
    display: none;
  }
}
</style>
<style scoped></style>
